;(function (angular, _, moment) {
  'use strict'
  angular.module('kilo.routes.dashboard')
    .controller('CardCreationModalController', CardCreationModalController)

  CardCreationModalController.$inject = [
    // Angular
    '$filter', '$timeout',
    // Libs
    '$uibModalInstance',
    // Managers
    // Services
    'ColorService', 'FilterService', 'StatusService',
    // Const
    // Resolved
    'card'
  ]

  function CardCreationModalController (
    // Angular
    $filter, $timeout,
    // Libs
    $uibModalInstance,
    // Managers
    // Services
    ColorService, FilterService, StatusService,
    // Const
    // Resolved
    card
  ) {
    var self = this
    var colors = [{
      text: 'BLANC',
      color: '#FFFFFF'
    }, {
      text: 'VERT',
      color: '#4CAF50'
    }, {
      text: 'BLEU',
      color: '#2196F3'
    }, {
      text: 'JAUNE',
      color: '#FFEB3B'
    }, {
      text: 'ORANGE',
      color: '#FF9800'
    }, {
      text: 'GRIS',
      color: '#9E9E9E'
    }, {
      text: 'ROUGE',
      color: '#F44336'
    }, {
      text: 'NOIR',
      color: '#000000'
    }, {
      text: 'ROSE',
      color: '#E91E63'
    }, {
      text: 'VIOLET',
      color: '#9C27B0'
    }]

    var graphData = [
      [65, 59, 80, -50, 56, 55, 40]
    ]

    var graphLabel = ['Groupe 1', 'Groupe 2', 'Groupe 3', 'Groupe 4', 'Groupe 5', 'Groupe 6', 'Groupe 7']

    var graphConfiguration = {
      layout: {
        padding: {
          left: 0,
          right: 10,
          top: 10,
          bottom: 10
        }
      },
      scales: {
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: $filter('cardConcern')(_.get(self, 'card.concern'))
            },
            ticks: {
              callback: function (label, index, labels) {
                if (self.card.type === 'financial') {
                  return $filter('numeral')(label)
                }
                return label
              },
              beginAtZero: true
            }
          }
        ],
        xAxes: [
          {
            display: false, // TMP ISSUE ON CHARTJS https://github.com/chartjs/Chart.js/issues/3694
            scaleLabel: {
              display: true,
              labelString: $filter('graphAxis')(_.get(self, 'card.groupBy.value'))
            }
          }
        ]
      },
      maintainAspectRatio: false,
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            if (self.card.type === 'financial') {
              return $filter('numeral')(data.datasets[0].data[tooltipItem.index])
            }
            return data.datasets[0].data[tooltipItem.index]
          }
        }
      }
    }

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        archive: [
          { label: 'Non-archivées', value: false, _id: 'archived' },
          { label: 'Archivées', value: true, _id: 'archived' },
          { label: 'Toutes', value: 'both', _id: 'archived' }
        ],
        card: card,
        colors: colors,
        graphConfiguration: graphConfiguration,
        graphData: graphData,
        graphLabel: graphLabel,
        invoiceStatuses: StatusService.getStatuses('invoice'),
        quoteStatuses: StatusService.getStatuses('quote'),
        creditNoteStatuses: StatusService.getStatuses('creditnote'),
        step: 1,
        // Public Methods
        checkValidity: checkValidity,
        close: close,
        getCorrectTemplate: getCorrectTemplate,
        getGroupByOptions: getGroupByOptions,
        getTextColor: getTextColor,
        nextStep: nextStep,
        ok: ok,
        previousStep: previousStep,
        resetPeriodicity: resetPeriodicity,
        selectConcern: selectConcern,
        selectDisplay: selectDisplay,
        selectType: selectType
      })

      init()
    }

    function init () {
      if (!self.card.query) {
        resetQuery()
      }
    }

    function selectConcern (concern) {
      if (!concern) {
        return
      }
      switch (concern) {
        case 'balance':
          self.card.type = 'financial'
          break
        case 'product':
          self.card.type = 'quantity'
          break
        default:
      }
      resetQuery()

      self.card.concern = concern
      self.card.display = {}
      self.card.groupBy = null
      self.graphConfiguration.scales.yAxes[0].scaleLabel.labelString = $filter('cardConcern')(_.get(self, 'card.concern'))
    }

    function selectType (type) {
      if (!type) {
        return
      }
      self.card.type = type
    }

    function selectDisplay (display) {
      if (!display) {
        return
      }
      _.set(self.card, 'display.type', display)
    }

    function checkValidity () {
      let validity = true
      switch (self.step) {
        case 1:
          if (!self.card.name) {
            validity = false
          }
          if (!self.card.concern) {
            validity = false
          }
          if (!self.card.type) {
            validity = false
          }
          break
        case 2:
          if (!_.get(self.card, 'display.type')) {
            validity = false
          }
          break
        case 3:
          if (self.card.display.type !== 'number' && !self.card.groupBy) {
            validity = false
          }
          break
      }
      return validity
    }

    function nextStep () {
      self.step += 1
      switch (self.step) {
        case 3:
          if (self.card.display.type === 'number') {
            self.card.groupBy = null
          } else {
            if (!self.card.groupBy) {
              self.card.groupBy = getGroupByOptions()[0]
            }
            self.graphConfiguration.scales.xAxes[0].scaleLabel.labelString = $filter('graphAxis')(_.get(self, 'card.groupBy.value'))
          }
          break
      }
    }

    function previousStep () {
      if (self.step > 1) {
        self.step -= 1
      }
    }

    function getCorrectTemplate () {
      if (_.get(self.card, 'display.type')) {
        switch (self.card.display.type) {
          case 'number':
            return '/app/modules/dashboard/services/templates/number.template.html'
          case 'histogram':
          case 'circular':
          case 'cloud':
            return '/app/modules/dashboard/services/templates/graph.template.html'
        }
      }
    }

    function getTextColor () {
      return ColorService.getLuminance(self.card.color) < 200 ? '#FFFFFF' : '#000000'
    }

    function resetQuery () {
      self.card.query = {}
      addCriteria('isArchived', { _id: 'archived', value: false })
    }

    function addCriteria (key, value, negation) {
      if (value !== undefined && value !== null) {
        self.card.query = FilterService.addCriteria(self.card.query, key, value, negation)
      }
      self.card.query = FilterService.sanitizeSearchTree(self.card.query, true)
    }

    function getGroupByOptions () {
      switch (self.card.concern) {
        case 'invoice':
        case 'quote':
        case 'creditnote':
        case 'deposit':
          return [
            {
              value: 'client',
              name: 'Client'
            },
            {
              value: 'status',
              name: 'État'
            },
            {
              value: 'tags',
              name: 'Mot clé'
            },
            {
              value: 'date',
              name: 'Date d\'émission'
            },
            {
              value: 'dueDate',
              name: 'Date d\'échéance'
            },
            {
              value: 'createdAt',
              name: 'Date de création'
            },
            {
              value: 'referers',
              name: 'Référent'
            }
          ]
        case 'product':
          return [
            {
              value: 'category',
              name: 'Catégorie'
            },
            {
              value: 'tags',
              name: 'Mot clé'
            }
          ]
        case 'balance':
          return [
            {
              value: 'client',
              name: 'Client'
            }
          ]
      }
    }

    function resetPeriodicity () {
      self.graphConfiguration.scales.xAxes[0].scaleLabel.labelString = $filter('graphAxis')(_.get(self, 'card.groupBy.value'))
      if (!(_.get(self.card, 'groupBy.value') === 'date' || _.get(self.card, 'groupBy.value') === 'dueDate')) {
        self.card.display.configuration = ''
      } else {
        self.card.display.configuration = 'monthly'
      }
    }

    function close () {
      $uibModalInstance.dismiss()
    }

    function ok () {
      if (!self.card.color) {
        self.card.color = '#FFFFFF'
      }
      $uibModalInstance.close(self.card)
    }
  }
})(window.angular, window._, window.moment)
